import React, { Component } from 'react';
import APIHandler from '../../utilities/apiHandler.js';
import FileSaver from 'file-saver';
import CircularProgress from '@material-ui/core/CircularProgress';

export default class fileDownload extends Component{
	constructor(props){
		super(props);
		this.state = {
			showLoader: false
		}
		this.downloadFile = this.downloadFile.bind(this);
	}

	downloadFile() {
		if(this.props.url) {
			this.setState({showLoader: true});
			APIHandler.fileDownloadHttpGet(this.props.url)
			.then(function(response) {
				response.data.blob().then(function(data) {
					var blob = new Blob([data], {
                    	type: response.mime
                	});
                	FileSaver.saveAs(blob, response.name);
				})
			}).catch(function(error) {
			}).finally(function(data) {
				this.setState({showLoader: false});
			}.bind(this))
		}
	}

	render() {
		return(
			<div>
				<button className="btn btn-jt-ops" onClick={this.downloadFile}>
					{this.props.title} 
					{(this.state.showLoader)?
						<CircularProgress size={18} thickness={5} style={{color:'#fff'}} />:null
					}
				</button>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/common/fileDownload/fileDownload.js